import { useMemo, useState } from 'react';

import { useQuery } from '@mint-lib/query-client';
import { Chat } from '@mint-sdk/api-ai-assistant';

const isUserMessage = (
  message: Chat.ChatMessageRecordType,
): message is Chat.UserChatMessageRecordType => {
  return message.message.type === 'human';
};

const useSelectedFiles = (chatId?: string) => {
  const [userFiles, setUserFiles] = useState<string[]>([]);
  const [userFolders, setUserFolders] = useState<string[]>([]);

  const { data: chatMessages = [] } = useQuery({
    ...Chat.getHistoryById({ urlParams: { chatSessionId: chatId || '' } }),
    staleTime: Infinity,
    enabled: !!chatId,
  });

  const historyFiles = useMemo(() => {
    const userMessages = chatMessages.filter(isUserMessage);
    const lastUserMsg = userMessages?.at(-1);
    return lastUserMsg?.message.additionalMetadata?.metadata?.targetFiles ?? [];
  }, [chatMessages]);

  return {
    selectedFiles: userFiles.length ? userFiles : historyFiles,
    setSelectedFiles: setUserFiles,
    selectedFolders: userFolders,
    setSelectedFolders: setUserFolders,
  };
};

export { useSelectedFiles };
